import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
//import "firebase/firestore";
//import "firebase/messaging";
//import "firebase/functions";

import '@material/fab/dist/mdc.fab.css';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/dialog/dist/mdc.dialog.css';
import '@material/button/dist/mdc.button.css';
import '@material/drawer/dist/mdc.drawer.css';
import '@material/list/dist/mdc.list.css';
import '@material/icon-button/dist/mdc.icon-button.css';
import '@material/form-field/dist/mdc.form-field.css';
import '@material/checkbox/dist/mdc.checkbox.css';

// Firebase App is always required and must be first

// Add additional services that you want to use

// Comment out (or don't require) services that you don't want to use
// require("firebase/storage");

var config = {
  apiKey: "AIzaSyCIW2GchrE3r5Gyv9l0z6-rSiX3izhISio",
  authDomain: "mbc-tool.firebaseapp.com",
  databaseURL: "https://mbc-tool.firebaseio.com",
  projectId: "mbc-tool",
  storageBucket: "mbc-tool.appspot.com",
  messagingSenderId: "722372598798"
};
const firebaseApp = firebase.initializeApp(config);
Vue.prototype.$firebase = firebaseApp;

Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js